import { render, staticRenderFns } from "./VersionLog.vue?vue&type=template&id=5be8c813"
import script from "./VersionLog.vue?vue&type=script&lang=js"
export * from "./VersionLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports